/**
 * Expression collection
 * @typedef {Object}  class_Exp Class Expression.
 * @property {String} name Expression ID.
 * @property {String} expression Regular Expression.
 * @property {String} message Test message.
 * @property {HTMLUListElement}  li list item.
 */

/**
 * Set up for PasswordWidget
 * @typedef {Object} Widget_PWD_Params widget password params.
 * @property {Array.<class_Exp>} classes  testing expression collection.
 */



/**
 * Point to valid subexpression test.
 */
class PasswordWidget {
    /**
     * @constructor
     * @param {HTMLInputElement} pInputControl HTML input element
     */
    constructor(pInputControl) {

        if (!pInputControl || !(pInputControl instanceof HTMLInputElement)) throw new Error(`Invalid input text ${pInputControl}`)

        // declare variables

        /**
         * @type {Widget_PWD_Params}
         */
        let objDataParams = JSON.parse(pInputControl.dataset.widgetParam);
        // validate input params
        if (!objDataParams || !Array.isArray(objDataParams.classes) || objDataParams.classes.length == 0 ||
            !objDataParams.classes.every(c => (!!c.expression && !!c.message && !!c.name))) {
            throw new Error(`Invalid widget Params : Missing classes option.`)
        }

        /**
         * @type {HTMLInputElement} HTML input element where widget is attached.
         */
        this.TextInput = pInputControl;
        /**
         * @type {Array.<class_Exp>} Array of expression to test.
         */
        this.Classes = objDataParams.classes;
        /**
         * @type {Object} bootstrap.Dropdown
         */
        this.Dropdown = null;

        this.init();

    }
    /**
     * Initialize widget
     */
    init() {
        let parentDiv = this.TextInput.closest('div'), // Designer must code "div"  as container for the password field.
            listOfDrowdown = document.createElement('UL'), // expression box
            listItem = document.createElement('LI'), // Each expression to test
            clonedListItem = null, // build each item
            innerText = null, // message to the user for each expression
            inputCheck = document.createElement('INPUT'), // check for valid input
            textLabel = !this.TextInput.name ? this.TextInput.id : this.TextInput.name,
            objThis = this;

        // Build parent elements
        parentDiv.classList.add('dropdown');
        listOfDrowdown.classList.add('dropdown-menu');
        listOfDrowdown.classList.add('dropdown-menu-end');
        listOfDrowdown.classList.add('p-1');
        parentDiv.appendChild(listOfDrowdown);

        !!textLabel && (listOfDrowdown.setAttribute('aria-labelledby', textLabel));

        //Build list item template
        listItem.classList.add('list-group-item');
        listItem.setAttribute('aria-disabled', 'true');
        inputCheck.type = 'checkbox';
        inputCheck.value = '';
        inputCheck.classList.add('form-check-input');
        inputCheck.classList.add('me-1');
        inputCheck.disabled = true;
        listItem.appendChild(inputCheck);

        // Build each list items
        this.Classes.forEach(c => {
            clonedListItem = listItem.cloneNode(true);
            clonedListItem.setAttribute('aria-label', c.message);
            clonedListItem.dataset.widgetClass = c.name;
            clonedListItem.dataset.widgetClassExp = c.expression
            innerText = document.createTextNode(c.message);
            clonedListItem.appendChild(innerText);
            c.li = listOfDrowdown.appendChild(clonedListItem);
            c.li.inputCheck = c.li.querySelector('input[type="checkbox"]');
        });
        //Build dropdown
        this.Dropdown = new bootstrap.Dropdown(parentDiv);
        //Show widget
        this.TextInput.addEventListener('focus', () => {
            objThis.Dropdown.show();
        }, false);
        //Hide Widget
        this.TextInput.addEventListener('blur', () => {
            objThis.Dropdown.hide();
        }, false);
        // catch entry data for input text field
        this.TextInput.addEventListener('input', this.evalRegularExpressions.bind(this), false);
    }
    /**
     * Set input checked attribute to true if the current value is tested as true
     * @param {Object} event 
     */
    evalRegularExpressions(evt) {
        let objRegExp = null,
            strValue = `${this.TextInput.value}`;
        this.Classes.forEach(c => {
            objRegExp = new RegExp(c.expression);
            if (objRegExp.test(strValue)) {
                c.li.inputCheck.checked = true;
            } else {
                c.li.inputCheck.checked = false;
            }
        });
    }
}


/**
 * Build hidden input text from date parts
 */
class DatePartWidget {
    constructor(pInputDatePart) {
        if (!pInputDatePart || !(pInputDatePart instanceof HTMLSelectElement || pInputDatePart instanceof HTMLInputElement)) throw new Error(`Invalid HTML Element ${pInputDatePart}`)

        let params = JSON.parse(pInputDatePart.dataset.widgetParam)

        /**
         * Hidden input selector
         * @type {String} 
         */
        this.InputHiddenSelector = pInputDatePart.dataset.widgetTarget;
        /**
         * Date part
         * @type {String} 
         */
        this.DatePartParam = params.part;
        /**
         * Default Value
         * @type {String} 
         */
        this.DefaultValueParam = !!params.value ? params.value : 'null';
        /**
         * Aria for assisted technologies.
         * @type {String} 
         */
        this.AriaDescribedBYParam = !!params.describedby ? params.describedby : '';
        /**
         * Message Error for {@link ValidationMethods_JS.dateISO8601Eval}
         * @type {String} 
         */
        this.ValMessageParam = !!params.eval ? params.eval : '';
        /**
         * input date part.
         * @type {HTMLSelectElement | HTMLInputElement} 
         */
        this.HTMLInputDatePart = pInputDatePart;


        if (!this.InputHiddenSelector) throw new Error(`Invalid widget target ${pInputDatePart.dataset.widgetTarget}`);
        if (!this.DatePartParam || !(this.DatePartParam.includes('yyyy') || this.DatePartParam.includes('MM') || this.DatePartParam.includes('dd'))) {
            throw new Error(`Invalid widget part param ${pInputDatePart.dataset.widgetParam}`);
        }

        this.init();
    }
    /**
     * Initialize widget
     */
    init() {
        let inputHidden = document.querySelector(this.InputHiddenSelector);

        if (!inputHidden) {
            inputHidden = document.createElement('INPUT');
            inputHidden.type = "hidden";
            inputHidden.name = this.InputHiddenSelector.replace('#', '').replace('.', '');
            inputHidden.id = inputHidden.name;
            inputHidden.setAttribute('aria-describedby', this.AriaDescribedBYParam);
            inputHidden.dataset.val = 'true';
            inputHidden.dataset.valDate = this.ValMessageParam;
            inputHidden.dataset.widgetRelatedTo = !!this.HTMLInputDatePart.id ? this.HTMLInputDatePart.id : '';
            inputHidden.dataset.valNoTransmit = "true";
            inputHidden.value = '';
            this.HTMLInputDatePart.insertAdjacentElement('beforebegin', inputHidden);
        } else {
            inputHidden.dataset.widgetRelatedTo = `${inputHidden.dataset.widgetRelatedTo} ${this.HTMLInputDatePart.id}`;
        }

        this.updateCurrentDate(inputHidden, {});

        this.HTMLInputDatePart.addEventListener('change', this.updateCurrentDate.bind(this, inputHidden), false);
    }
    /**
     * Update value on the hidden input.
     * @param {HTMLInputElement} inputHidden hidden input full date text.
     * @param {Event} evt event object
     */
    updateCurrentDate(inputHidden, evt) {
        let _year,
            _month,
            _day,
            _defaultValue = parseInt(this.DefaultValueParam),
            isFromChangeEvent = !!evt.currentTarget, // set true if this method was called by change event.
            _changedValue = parseInt(isFromChangeEvent ? evt.currentTarget.value : ''),
            _valueToUpdate = '';

        // get current values
        !!inputHidden.value && ([_year, _month, _day] = inputHidden.value.split('-'));

        if (isFromChangeEvent) {
            _valueToUpdate = _changedValue;
        } else {
            _valueToUpdate = _defaultValue;
        }
        // initializes not numbet value
        isNaN(_valueToUpdate) && (_valueToUpdate = 0);
        //update new value
        switch (this.DatePartParam) {
            case 'yyyy':
                _year = `${'0000'}${_valueToUpdate}`.slice(-4);
                break;
            case 'MM':
                _month = `${'00'}${_valueToUpdate}`.slice(-2);
                break;
            case 'dd':
                _day = `${'00'}${_valueToUpdate}`.slice(-2);
        }
        //rebuild new value
        inputHidden.value = `${_year}-${_month}-${_day}`;
    }
}

/**
 * @typedef {Object} recaptcha_collection widget recaptcha params.
 * @property {String} version recaptcha version.
 * @property {String} message error message.
 * @property {String} target input field for saving recaptcha value.
 * @property {HTMLInputElement} inputForm Input HTML Element that receives token value after a successful response.
 * @property {GrecaptchaV2_JS} grecaptchaV2 Google recaptcha.
 */

/**
 * Build Widget for repeated checkbox recatpchas
 */
class RecaptchaWidget {
    /**
     * @param {Object} pGrecaptcha grecaptcha object.
     * @param {Array.<HTMLInputElement>} pRecaptchaCollection array of widget recaptcha inputs.
     * @param {String} pGeneralMessage error message.
     * @param {GRECAPTCHA_OPTIONS} pOptions GrecaptchaV2_JS options.
     */
    constructor(pGrecaptcha, pRecaptchaCollection, pGeneralMessage, pOptions) {
        if (!pGrecaptcha) {
            throw new Error('Missing grecaptcha object.');
        }
        /**
         * Flag to signal has recaptcha token value.
         * @type {Boolean} 
         */
        this.HasValue = false;
        /**
         * General Error message.
         * @type {String}
         */
        this.ErrorMessage = pGeneralMessage;
        /**
         * several recaptchas in a form.
         * @type {Array.<recaptcha_collection>}
         */
        this.RecaptchaCollection = (!!pRecaptchaCollection && pRecaptchaCollection.length > 0) &&
            (
                pRecaptchaCollection = [].slice.call(pRecaptchaCollection, 0)
                ,
                pRecaptchaCollection.map(r => {
                    // Load widget params
                    let widgetParams = !!r.dataset.widgetParam ? JSON.parse(r.dataset.widgetParam) : {},
                        defaultOptions = {
                            version: "2.0",
                            message: "Valida el recaptcha para continuar.",
                            target: r.dataset.widgetTarget,
                            inputForm: r
                        };
                    Object.assign(defaultOptions, widgetParams);
                    return defaultOptions;
                })
            );

        this.init(pOptions, pGrecaptcha);
    }
    /**
     * Load serveral recaptchas belonged to the same siteKey.
     * @param {GRECAPTCHA_OPTIONS} pOptions 
     */
    init(pOptions, pGrecaptcha) {
        if (!this.RecaptchaCollection) {
            throw new Error('RecaptchaWidget: Missing input recaptcha collection.');
        }

        this.RecaptchaCollection.forEach(or => {
            let options = {
                selector: or.target,
                inputForm: or.inputForm,
                callback: this.resetRestAfterchecked(),
                expiredCallback: this.expiredWidgetRecaptcha(),
                ...pOptions
            };
            Object.assign(options, pOptions)
            if (or.version === "2.0") {
                or.grecaptchaV2 = new GrecaptchaV2_JS(pGrecaptcha, options);
            }
        });
    }
    /**
     * Reset all Recaptcha.
     */
    reset() {
        this.RecaptchaCollection.forEach(or => or.grecaptchaV2.reset());
    }
    /**
     * Set a function to reset all recaptcha except  checked recaptcha.
     * @returns {Function} reset all recaptcha except  checked recaptcha fuction.
     */
    resetRestAfterchecked() {
        const objThis = this;
        return () => {
            let arrayCheckedRecaptcha = objThis.RecaptchaCollection.filter(or => or.grecaptchaV2.getResponse().length > 0);
            if (!!arrayCheckedRecaptcha && arrayCheckedRecaptcha.length > 0) {
                objThis.RecaptchaCollection.forEach(or => {
                    (or.grecaptchaV2.widget_id != arrayCheckedRecaptcha[0].grecaptchaV2.widget_id) && or.grecaptchaV2.reset();
                });
            }
            objThis.HasValue = true;
        }
    }
    /**
     * Set a function to set HasValue flag to true.
     * @returns {Function} function to set HasValue flag to true.
     */
    expiredWidgetRecaptcha() {
        const objThis = this;
        return () => {
            let arrayCheckedRecaptcha = objThis.RecaptchaCollection.filter(or => or.grecaptchaV2.getResponse().length > 0);
            if (!!arrayCheckedRecaptcha && arrayCheckedRecaptcha.length > 0) {
                objThis.HasValue = true;
            } else {
                objThis.HasValue = false;
            }
        }
    }
    /**
     * get Recaptcha value
     * @returns {String} Recaptch token value
     */
    getResponse() {
        let tokenValue = '';
        this.RecaptchaCollection.some(or => {
            tokenValue = or.grecaptchaV2.RecaptchaValue;
            return or.grecaptchaV2.isValid()
        });
        return tokenValue;
    }
}